var ne = Object.defineProperty, oe = Object.defineProperties;
var te = Object.getOwnPropertyDescriptors;
var X = Object.getOwnPropertySymbols;
var de = Object.prototype.hasOwnProperty, ce = Object.prototype.propertyIsEnumerable;
var Y = (d, l, t) => l in d ? ne(d, l, { enumerable: !0, configurable: !0, writable: !0, value: t }) : d[l] = t, Z = (d, l) => {
  for (var t in l || (l = {}))
    de.call(l, t) && Y(d, t, l[t]);
  if (X)
    for (var t of X(l))
      ce.call(l, t) && Y(d, t, l[t]);
  return d;
}, ee = (d, l) => oe(d, te(l));
var q = (d, l, t) => new Promise((b, m) => {
  var w = (u) => {
    try {
      p(t.next(u));
    } catch (h) {
      m(h);
    }
  }, _ = (u) => {
    try {
      p(t.throw(u));
    } catch (h) {
      m(h);
    }
  }, p = (u) => u.done ? b(u.value) : Promise.resolve(u.value).then(w, _);
  p((t = t.apply(d, l)).next());
});
const re = {
  "@didi/hawaii-map-api": "^2.3.9-rc.5",
  "@didi/hawaii-map-plugin": "^2.3.9-rc.5"
};
function fe(d) {
  function l(f, c) {
    return f << c | f >>> 32 - c;
  }
  function t(f, c) {
    var s, x, v, S, g;
    return v = f & 2147483648, S = c & 2147483648, s = f & 1073741824, x = c & 1073741824, g = (f & 1073741823) + (c & 1073741823), s & x ? g ^ 2147483648 ^ v ^ S : s | x ? g & 1073741824 ? g ^ 3221225472 ^ v ^ S : g ^ 1073741824 ^ v ^ S : g ^ v ^ S;
  }
  function b(f, c, s) {
    return f & c | ~f & s;
  }
  function m(f, c, s) {
    return f & s | c & ~s;
  }
  function w(f, c, s) {
    return f ^ c ^ s;
  }
  function _(f, c, s) {
    return c ^ (f | ~s);
  }
  function p(f, c, s, x, v, S, g) {
    return f = t(
      f,
      t(t(b(c, s, x), v), g)
    ), t(l(f, S), c);
  }
  function u(f, c, s, x, v, S, g) {
    return f = t(
      f,
      t(t(m(c, s, x), v), g)
    ), t(l(f, S), c);
  }
  function h(f, c, s, x, v, S, g) {
    return f = t(
      f,
      t(t(w(c, s, x), v), g)
    ), t(l(f, S), c);
  }
  function y(f, c, s, x, v, S, g) {
    return f = t(
      f,
      t(t(_(c, s, x), v), g)
    ), t(l(f, S), c);
  }
  function ae(f) {
    for (var c, s = f.length, x = s + 8, v = (x - x % 64) / 64, S = (v + 1) * 16, g = Array(S - 1), U = 0, $ = 0; $ < s; )
      c = ($ - $ % 4) / 4, U = $ % 4 * 8, g[c] = g[c] | f.charCodeAt($) << U, $++;
    return c = ($ - $ % 4) / 4, U = $ % 4 * 8, g[c] = g[c] | 128 << U, g[S - 2] = s << 3, g[S - 1] = s >>> 29, g;
  }
  function C(f) {
    var c = "", s = "", x, v;
    for (v = 0; v <= 3; v++)
      x = f >>> v * 8 & 255, s = "0" + x.toString(16), c = c + s.substr(s.length - 2, 2);
    return c;
  }
  function ie(f) {
    f = f.replace(/\r\n/g, `
`);
    for (var c = "", s = 0; s < f.length; s++) {
      var x = f.charCodeAt(s);
      x < 128 ? c += String.fromCharCode(x) : x > 127 && x < 2048 ? (c += String.fromCharCode(x >> 6 | 192), c += String.fromCharCode(x & 63 | 128)) : (c += String.fromCharCode(x >> 12 | 224), c += String.fromCharCode(x >> 6 & 63 | 128), c += String.fromCharCode(x & 63 | 128));
    }
    return c;
  }
  var o = Array(), n, N, R, z, Q, e, r, a, i, H = 7, k = 12, M = 17, P = 22, W = 5, j = 9, I = 14, E = 20, O = 4, K = 11, V = 16, D = 23, L = 6, B = 10, G = 15, T = 21;
  for (d = ie(d), o = ae(d), e = 1732584193, r = 4023233417, a = 2562383102, i = 271733878, n = 0; n < o.length; n += 16)
    N = e, R = r, z = a, Q = i, e = p(e, r, a, i, o[n + 0], H, 3614090360), i = p(i, e, r, a, o[n + 1], k, 3905402710), a = p(a, i, e, r, o[n + 2], M, 606105819), r = p(r, a, i, e, o[n + 3], P, 3250441966), e = p(e, r, a, i, o[n + 4], H, 4118548399), i = p(i, e, r, a, o[n + 5], k, 1200080426), a = p(a, i, e, r, o[n + 6], M, 2821735955), r = p(r, a, i, e, o[n + 7], P, 4249261313), e = p(e, r, a, i, o[n + 8], H, 1770035416), i = p(i, e, r, a, o[n + 9], k, 2336552879), a = p(a, i, e, r, o[n + 10], M, 4294925233), r = p(r, a, i, e, o[n + 11], P, 2304563134), e = p(e, r, a, i, o[n + 12], H, 1804603682), i = p(i, e, r, a, o[n + 13], k, 4254626195), a = p(a, i, e, r, o[n + 14], M, 2792965006), r = p(r, a, i, e, o[n + 15], P, 1236535329), e = u(e, r, a, i, o[n + 1], W, 4129170786), i = u(i, e, r, a, o[n + 6], j, 3225465664), a = u(a, i, e, r, o[n + 11], I, 643717713), r = u(r, a, i, e, o[n + 0], E, 3921069994), e = u(e, r, a, i, o[n + 5], W, 3593408605), i = u(i, e, r, a, o[n + 10], j, 38016083), a = u(a, i, e, r, o[n + 15], I, 3634488961), r = u(r, a, i, e, o[n + 4], E, 3889429448), e = u(e, r, a, i, o[n + 9], W, 568446438), i = u(i, e, r, a, o[n + 14], j, 3275163606), a = u(a, i, e, r, o[n + 3], I, 4107603335), r = u(r, a, i, e, o[n + 8], E, 1163531501), e = u(e, r, a, i, o[n + 13], W, 2850285829), i = u(i, e, r, a, o[n + 2], j, 4243563512), a = u(a, i, e, r, o[n + 7], I, 1735328473), r = u(r, a, i, e, o[n + 12], E, 2368359562), e = h(e, r, a, i, o[n + 5], O, 4294588738), i = h(i, e, r, a, o[n + 8], K, 2272392833), a = h(a, i, e, r, o[n + 11], V, 1839030562), r = h(r, a, i, e, o[n + 14], D, 4259657740), e = h(e, r, a, i, o[n + 1], O, 2763975236), i = h(i, e, r, a, o[n + 4], K, 1272893353), a = h(a, i, e, r, o[n + 7], V, 4139469664), r = h(r, a, i, e, o[n + 10], D, 3200236656), e = h(e, r, a, i, o[n + 13], O, 681279174), i = h(i, e, r, a, o[n + 0], K, 3936430074), a = h(a, i, e, r, o[n + 3], V, 3572445317), r = h(r, a, i, e, o[n + 6], D, 76029189), e = h(e, r, a, i, o[n + 9], O, 3654602809), i = h(i, e, r, a, o[n + 12], K, 3873151461), a = h(a, i, e, r, o[n + 15], V, 530742520), r = h(r, a, i, e, o[n + 2], D, 3299628645), e = y(e, r, a, i, o[n + 0], L, 4096336452), i = y(i, e, r, a, o[n + 7], B, 1126891415), a = y(a, i, e, r, o[n + 14], G, 2878612391), r = y(r, a, i, e, o[n + 5], T, 4237533241), e = y(e, r, a, i, o[n + 12], L, 1700485571), i = y(i, e, r, a, o[n + 3], B, 2399980690), a = y(a, i, e, r, o[n + 10], G, 4293915773), r = y(r, a, i, e, o[n + 1], T, 2240044497), e = y(e, r, a, i, o[n + 8], L, 1873313359), i = y(i, e, r, a, o[n + 15], B, 4264355552), a = y(a, i, e, r, o[n + 6], G, 2734768916), r = y(r, a, i, e, o[n + 13], T, 1309151649), e = y(e, r, a, i, o[n + 4], L, 4149444226), i = y(i, e, r, a, o[n + 11], B, 3174756917), a = y(a, i, e, r, o[n + 2], G, 718787259), r = y(r, a, i, e, o[n + 9], T, 3951481745), e = t(e, N), r = t(r, R), a = t(a, z), i = t(i, Q);
  return (C(e) + C(r) + C(a) + C(i)).toLowerCase();
}
const le = (d, l, t, b) => q(void 0, null, function* () {
  try {
    let m = "";
    for (const y in t)
      m += `&${y}=${t[y]}`;
    m = m.slice(1);
    const w = (/* @__PURE__ */ new Date()).valueOf().toString(), p = yield fetch(
      `https://web.map.xiaojukeji.com/mp_dolphin_node_server/dataConfigPlatform/api/graphql/${d}?${m}`,
      {
        headers: {
          callerid: b,
          version: "V2",
          "dcp-timestamp": w,
          "dcp-sign": se(b, w, t)
        }
      }
    ), { metadata: u, results: h } = yield p.json();
    return u.msgId ? [u.msgInfo, null] : ["", h[l][0]];
  } catch (m) {
    return [m.message, null];
  }
});
function se(d, l, t) {
  const b = [], m = Object.keys(t).sort();
  for (const w of m) {
    const _ = typeof t[w] == "object" ? JSON.stringify(t[w]) : t[w];
    b.push(`${w}=${_}`);
  }
  return b.push(`callerid=${d}`), b.push(`timestamp=${l}`), fe(b.join("&")).toUpperCase();
}
let F = re["@didi/hawaii-map-api"].slice(1), J = re["@didi/hawaii-map-plugin"].slice(1), A = "https://s3-gz01.didistatic.com/hawaii-web-sdk";
const he = {
  load: (d) => q(void 0, null, function* () {
    var m;
    ue(d.appKey);
    const l = "https://s3-gz01.didistatic.com/hawaii-web-sdk/style/standard/standard2.json";
    A = d.cdnDomain || A, d.module = d.module || "iife", d.glversion = d.glversion || "2.0.6", yield xe({
      scriptSrc: `${A}/web_hawaii_gl/${d.glversion}/hawaiimap-gl-${d.module}.js`,
      styleSrc: `${A}/web_hawaii_gl/${d.glversion}/hawaiimap-gl.css`,
      glStyleSrc: l
    }), typeof d.version == "string" ? F = d.version : F = ((m = d.version) == null ? void 0 : m.pluginVersion) || F;
    const t = yield me(
      `${A}/web_hawaii_api/${F}/api_${d.module}.js`,
      d.appKey,
      d.module
    ), b = yield Promise.all(
      (d.plugins || []).map((w) => {
        var p;
        typeof d.version == "string" ? J = d.version : J = ((p = d.version) == null ? void 0 : p.pluginVersion) || J;
        const _ = `${A}/web_hawaii_api/${J}/plugin${w}_${d.module}.js`;
        return pe(
          _,
          w,
          d.appKey,
          d.module
        ).then((u) => ({
          key: w,
          plugin: u
        }));
      })
    );
    return {
      style: l,
      hawaiiMapApi: t,
      hawaiiMapPlugin: b.reduce(
        (w, _) => ee(Z({}, w), {
          [_.key]: _.plugin
        }),
        {}
      )
    };
  })
};
function ue(d) {
  return q(this, null, function* () {
    const [l, t] = yield le(
      "get__HAWAII_checkAppKey-763",
      "HAWAII_checkAppKey",
      {
        appKey: d
      },
      d
    );
    return l || !t ? [l, ""] : ["", t.style];
  });
}
function xe(d) {
  if (window.mapboxgl)
    return Promise.resolve({
      style: d.glStyleSrc
    });
  const l = document.createElement("script"), t = document.createElement("link");
  return l.src = d.scriptSrc, t.href = d.styleSrc, t.rel = "stylesheet", t.crossOrigin = "anonymous", document.head.append(l, t), new Promise((b) => {
    l.onload = () => {
      b({
        style: d.glStyleSrc
      });
    }, l.onerror = () => {
      throw new Error("[Load hawaii map sdk]: error!");
    };
  });
}
function me(d, l, t) {
  if (window.HawaiiMapApi)
    return Promise.resolve(window.HawaiiMapApi);
  const b = document.createElement("script");
  return b.src = `${d}?ak=${l}`, document.head.appendChild(b), new Promise((m) => {
    b.onload = () => {
      m(window.HawaiiMapApi), window.HawaiiMapApi || console.error(
        "hawaii-map-api load error!, window未挂载HawaiiMapApi或被覆盖"
      );
    }, b.onerror = () => {
      m(void 0), console.error("hawaii-map-api load error!");
    };
  });
}
function pe(d, l, t, b) {
  const m = `HawaiiMapPlugin${l}`;
  if (window[m])
    return Promise.resolve(window[m]);
  const w = document.createElement("script");
  return w.src = `${d}?ak=${t}`, document.head.appendChild(w), new Promise((_) => {
    w.onload = () => {
      _(window[m]), window[m] || console.error(
        "hawaii-map-api load error!, window未挂载" + m + "或被覆盖"
      );
    }, w.onerror = () => {
      _(void 0), console.error(`hawaii-map-plugin-${l} load error!`);
    };
  });
}
export {
  he as default
};
